<template>
  <section class="container my-4">
    <div>
      <div class="my-3" v-for="cartItem in cartItems" :key="cartItem.product.id">
        <div class="row justify-contents-center align-items-center">
          <div class="col-2">
            <img
              class="img-fluid"
              :src="cartItem.product.image ? cartItem.product.image.url : defaultImage"
            />
          </div>
          <div class="col-10">
            <div class="d-flex">
              <div class="flex-fill d-flex align-items-center">{{ cartItem.product.name }}</div>

              <span class="form-inline flex-fill">
                <NumberInputSpinner
                  :min="1"
                  :max="100"
                  :integerOnly="true"
                  v-model="cartItem.quantity"
                  v-on:input="(value)=>{cartItem.quantity = value ; updateItem(cartItem) }"
                />
              </span>

              <div
                class="flex-fill d-flex align-items-center"
              >{{ formatNumber(cartItem.product.price) }} تومان</div>
              <div
                class="flex-fill d-flex align-items-center"
              >{{ formatNumber(cartItem.product.price * cartItem.quantity) }} تومان</div>
              <button class="btn btn-link" @click="removeFromCart(cartItem.product_id)">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <hr />
      </div>
      <div v-if="cartItems.length === 0">
        <p>{{ cartEmptyLabel }}</p>
      </div>
    </div>

    <button v-show="cartItems.length > 0" class="btn btn-success" @click="onNextBtn">{{ buyLabel }}</button>
  </section>
</template>

<script>
import NumberInputSpinner from "@/components/NumberInputSpinner";

export default {
  name: "checkout-component",

  components: {
    NumberInputSpinner,
  },

  data() {
    return {
      removeLabel: "حذف",
      cartEmptyLabel: "موردی یافت نشد.",
      closeLabel: "بستن",
    };
  },

  computed: {
    cartItems() {
      return this.$store.getters.cartItems;
    },

    buyLabel() {
      let totalProducts = this.cartItems.reduce(
          (acc, product) => acc + product.quantity,
          0
        ),
        cartItems = this.$store.getters.cartItems,
        pricesArray = [],
        productLabel = "",
        finalPrice = "",
        quantity = 1;

      cartItems.forEach((cartItem) => {
        if (cartItem.quantity >= 1) {
          quantity = cartItem.quantity;
        }

        pricesArray.push(cartItem.product.price * quantity); // get the price of every product added and multiply quantity
      });

      finalPrice = pricesArray.reduce((a, b) => a + b, 0); // sum the prices

      if (totalProducts > 1) {
        // set plural or singular
        productLabel = "محصول";
      } else {
        productLabel = "محصول";
      }
      return `خرید ${totalProducts} ${productLabel}  ${finalPrice} تومان`;
    },

    isUserLoggedIn() {
      return this.$store.getters.isUserLoggedIn;
    },
  },

  methods: {
    removeFromCart(id) {
      this.$store.dispatch("removeFromCart", id);
    },

    updateItem(cartItem) {
      this.$store.dispatch("updateCartItem", cartItem);
    },

    onNextBtn() {
      if (this.isUserLoggedIn) {
        this.sendOrder();
      } else {
        this.$store.commit("showCheckoutModal", false);
        this.$store.commit("showLoginModal", true);
      }
    },
    onPrevBtn() {
      this.isCheckoutSection = false;
    },

    sendOrder() {
      this.$store
        .dispatch("checkout")
        .then(() => {
          this.isCheckoutSection = true;
        })
        .catch((e) => {
          this.isCheckoutSection = false;
        });
    },
  },
};
</script>
